module.exports = __webpack_public_path__ + "static/img/tube_landing_03.fd433e6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/tube_landing_03.jpg
// module id = SC/V
// module chunks = 0